import ionRangeSlider from 'ion-rangeslider';

$(document).ready(() => {
	const filterPriceSlider = $('.js-filterAgeSlider').ionRangeSlider({
		min: $(this).data('min'),
		max: $(this).data('max'),
		from: $(this).data('from'),
		force_edges: true,
		hide_from_to: true,
		hide_min_max: true,
		onUpdate: function(data){
			changeValue(data.from);
		},
		onChange: function(data){
			changeValue(data.from);
		},
		onFinish: function(data){
			changeValue(data.from);
		}
	}).data('ionRangeSlider');

	changeValue($('.js-filterAgeSlider').data('from'));

	function changeValue(value){
		const handle = $('.js-filterAgeSlider').parent().find('.irs-handle');

		handle.text(`${value}+`);
	}
});
